export const appDisabledLockedIcon = {
  data: `<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
            d="M2.97719 6.47825V4.06859C2.97719 2.37387 4.55401 1 6.50011 1C8.44569 1 10.023 2.37521 10.023 4.06859V6.47825H10.7377C11.4042 6.47825 11.9446 7.02425 11.9446 7.6947V13.7836C11.9446 14.4553 11.4046 15 10.7377 15H2.26257C1.59606 15 1.05566 14.454 1.05566 13.7836V7.6947C1.05566 7.0229 1.59565 6.47825 2.26257 6.47825H2.97719ZM2.33672 7.69563V13.7826H10.6635V7.69563H2.33672ZM8.74198 6.47825V4.06859C8.74198 3.07179 7.76135 2.21738 6.50011 2.21738C5.23803 2.21738 4.25824 3.07086 4.25824 4.06859V6.47825H8.74198Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="0.518519"
            transform="translate(0.5,0)"
    />
</svg>
`,
  name: 'disabled-locked',
};
